import { useState } from 'react';

function AppointmentForm() {
    const [formInputs, setFormInputs] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const formData = {
            firstName: formInputs.firstName,
            lastName: formInputs.lastName,
            phoneNumber: formInputs.phoneNumber,
            emailAddress: formInputs.emailAddress,
        };
        try {
            const response = await fetch('/api/contactUs', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                alert('Appointment request submitted successfully!');
            } else {
                alert('Failed to submit appointment request.');
            }
        } catch (error) {
            console.error('Error submitting appointment request:', error);
            alert('An error occurred while submitting the appointment request.');
        }
        setSubmitting(false);
    }

    return (
        <>
            <div className="appointment-form form-wraper mb-5">
                <h3 className="title">Request Appointment</h3>
                <form id="appointment-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input type="text" className="form-control" placeholder="First Name" value={formInputs.firstName} onChange={(e) => setFormInputs({ ...formInputs, firstName: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <input type="text" className="form-control" placeholder="Last Name" value={formInputs.lastName} onChange={(e) => setFormInputs({ ...formInputs, lastName: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <input type="tel" className="form-control" placeholder="Phone Number" value={formInputs.phoneNumber} onChange={(e) => setFormInputs({ ...formInputs, phoneNumber: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <input type="email" className="form-control" placeholder="Email Address" value={formInputs.emailAddress} onChange={(e) => setFormInputs({ ...formInputs, emailAddress: e.target.value })} />
                    </div>
                    <button type="submit" className="btn btn-secondary btn-lg" disabled={submitting}>
                        {submitting ? 'Submitting...' : 'Request Now'}
                    </button>
                </form>
            </div>
        </>
    );
}

export default AppointmentForm;